import { useEffect, useState } from "react";
import { toast } from "sonner";
import api, { downloadFile, formatApiErrorDetail } from "@/lib/api";
import { ManualReader } from "@/components/manual/ManualReader";

export default function ManualPage() {
  const [data, setData] = useState(null);
  const [downloading, setDownloading] = useState(false);

  useEffect(() => {
    api.get("/manual").then((r) => setData(r.data))
      .catch((e) => toast.error(formatApiErrorDetail(e.response?.data?.detail)));
  }, []);

  const download = async () => {
    setDownloading(true);
    try {
      await downloadFile("/manual/pdf", "administrator-manual.pdf");
    } catch {
      toast.error("Could not generate the PDF — try again");
    } finally {
      setDownloading(false);
    }
  };

  return (
    <div data-testid="manual-page">
      <ManualReader data={data} onDownload={download} downloading={downloading} />
    </div>
  );
}
